import { render, staticRenderFns } from "./SuggestKosiwonInfoModal.vue?vue&type=template&id=5c1f4c64&scoped=true&"
import script from "./SuggestKosiwonInfoModal.vue?vue&type=script&lang=js&"
export * from "./SuggestKosiwonInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./SuggestKosiwonInfoModal.vue?vue&type=style&index=0&id=5c1f4c64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f4c64",
  null
  
)

export default component.exports